import { useNavigate } from "react-router-dom";
import { clearAdminToken } from "../admin/auth";
import "../styles/AdminAuthButton.css";

function AdminAuthButton({ isAdmin, onLogout }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (isAdmin) {
      clearAdminToken();
      onLogout?.();
      navigate("/");
      return;
    }

    navigate("/admin/login");
  };

  return (
    <button
      type="button"
      className={`admin-auth-button ${isAdmin ? "logout" : "login"}`}
      onClick={handleClick}
    >
      {isAdmin ? "Выйти" : "Вход"}
    </button>
  );
}

export default AdminAuthButton;